import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useRejectLimitData } from "hooks/configs/reject-limit/useRejectLimitData";
import { useRejectLimitForm } from "hooks/configs/reject-limit/useRejectLimitForm";
import { PermissionGuard } from "components/configs/reject-limit/PermissionGuard";
import { PageHeader } from "components/configs/reject-limit/PageHeader";
import { RejectLimitForm } from "components/configs/reject-limit/RejectLimitForm";
import { LoadingSpinner } from "components/configs/reject-limit/LoadingSpinner";
import { ErrorMessage } from "components/configs/reject-limit/ErrorMessage";

const RejectLimitPage = (props) => {
  const { t, ready } = useTranslation();

  useEffect(() => {
    document.title = ready ? t("Satis client - Paramètre Limite de rejet") : "";
  }, [ready, t]);

  const { data, isLoading, error } = useRejectLimitData();
  const {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
  } = useRejectLimitForm(data);

  return (
    <PermissionGuard userPermissions={props.userPermissions} ready={ready}>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        id="kt_content"
      >
        <PageHeader t={t} />

        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="row">
            <div className="col">
              <div className="kt-portlet">
                <div className="kt-portlet__head">
                  <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                      {t("Limite de rejet après affectation")}
                    </h3>
                  </div>
                </div>

                {error && <ErrorMessage error={error} t={t} />}

                {isLoading ? (
                  <LoadingSpinner t={t} />
                ) : (
                  <RejectLimitForm
                    formData={formData}
                    errors={errors}
                    onFieldChange={updateField}
                    onSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    t={t}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PermissionGuard>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(RejectLimitPage);
